import React, { useState } from "react";
import Map from "../../components/Map";
import styled from "styled-components";
import Trips from "../../components/Trips";
import { useQuery } from "@tanstack/react-query";
import { fetchDrivers } from "../../services/map";
import Spinner from "../../components/Spinner";

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0 5%;
  gap: 1rem;

  @media (max-width: 992px) {
    flex-direction: column; /* stack map + trips */
    padding: 0 1rem;
  }
`;

const Home = () => {
  const [selectedDriver, setSelectedDriver] = useState(null);

  const {
    data: drivers = [],
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["waiting-drivers"],
    queryFn: fetchDrivers,
  });

  if (isLoading) return <Spinner />;
  if (isError) return <p>❌ خطأ في جلب البيانات: {error.message}</p>;

  return (
    <Flex>
      <Map
        drivers={drivers}
        selectedDriver={selectedDriver}
        setSelectedDriver={setSelectedDriver}
      />
      <Trips drivers={drivers} onSelectDriver={setSelectedDriver} />
    </Flex>
  );
};

export default Home;
